export const environment = {
  production: true,
  imgHost: '/client/dist/assets/images/',
  apiHost: 'https://go.hf-datalive.com',
  smartWitnessBaseUrl: 'https://uk.smartwitness.co',
  ssoAuthUrl: 'http://go.datalive.com/oauth2/',
  dataliveAuthHost: 'https://auth.datalive.com',
  safetyInspectionAppUrl: 'https://safetyinspection.datalive.com',
  safetyInspectionApiHost: 'https://api-dot-earned-recognition-production.appspot.com',
  defectAppUrl: 'https://defect.datalive.com',
  defectApiHost: 'https://api-dot-datalive-defect-report-prod.appspot.com',
  vehicleCheckApiHost: 'https://datalive-vehicle-check-prod.nw.r.appspot.com',
  vehicleUtilisationAppUrl: 'https://utilization.datalive.com',
  externalAppKeys: {
    dpd: 'fd2dd3cda9f333d60234a7b2'
  },
  externalAppLinks: {
    ER_DASHBOARD: 'https://er.datalive.com',
    SAFETY_INSPECTION: 'https://inspection.datalive.com',
    DEFECT: 'https://defect.datalive.com',
    DRIVER_AGENCY_ONBOARDING: 'https://onboarding.datalive.com',
    FMT: 'checkit.datalive.com',
    TACHOGRAF: 'https://idha.online/login'
  },
  developmentAccessToken: null
};



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/environments/environment.ts